var base = require('base/product/base');
var baseImported = require('./baseImportedFunctions');
var cartHelpers = require('../helpers/cartHelper');
const rykPDP = require('./rykPDP');

function clearDeskModal(content) {
    $('.modal-content.cristales__equal-modal-spacing').html('');
    $('.modal-content.cristales__equal-modal-spacing').html(content);

    const productType = $('input[data-tipo-producto]').first().val();
    const solSwitch = $('.js-sol-switch #switch-to-cristales');
    const isSol = productType === 'sol';

    var $defaultColumn = $(".pack-column[data-selected-lens]").first();

    if(productType !== 'sol' || (isSol && solSwitch && solSwitch.length && solSwitch.is(':checked'))) {
        rykPDP.toggleChangePriceTableModal($defaultColumn)
    }

    rykPDP.fixBronceTreatmentsOnLoad();
}

function erroQty () {
    let error= false;
    let qtyLeft = $('.receta-quant-left-eye').val();
    let isFlowStore = $('[data-flow-store-subscription]') ? $('[data-flow-store-subscription]').data('flow-store-subscription') : false;
    let qtyRight = $('.receta-quant-right-eye').val();
    let tipoProducto = $("[data-tipo-producto]").val();
    
    if (tipoProducto === "lenteContacto") {
        if (!isFlowStore && Number(qtyLeft) === 0 && Number(qtyRight) === 0 && !$('.tab-subscription-pdp.active').length > 0) {
            $('.quant-input').addClass('error-quantity');
            $.spinner().stop();
            error = true;
        } else {
            $('.quant-input').removeClass('error-quantity');
        }
    }
    return error;
}

function addToCartSendData (addToCartUrl,form) {
    const device = window.matchMedia('(max-device-width: 991px)').matches;
    if (erroQty()) {
        return;
    }
    let isMobile = false;
    let blueLigthSwitch = $('#filtro-azul-option-cristalesMobile');
    device ? isMobile = true : false;

    if(isMobile) {
        $('.close.cristales').trigger('click');
    }

    $.ajax({
        url: addToCartUrl,
        method: 'POST',
        data: form,
        success: function (data) {
            $('.close.cristales').trigger('click');
            baseImported.handlePostCartAdd(data);
            $('body').trigger('product:afterAddToCart', data);
            $.spinner().stop();
            base.miniCartReportingUrl(data.reportingURL);
            if(isMobile) {
                if (blueLigthSwitch.is(':checked')) {
                    blueLigthSwitch.trigger('click');
                }
                if (data.isProductSol) {
                    clearDeskModal(data.modalContentTemplate);
                    rykPDP.bttnSelectecGlass();
                } else {
                    rykPDP.init();
                }
            } else {
                if (data.modalContentTemplate) {
                    clearDeskModal(data.modalContentTemplate);
                }
            }
            // Activate event in to switch after modal Content Template delete all events
            rykPDP.addsExtraSwitchsChange();

            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

// Subscription add to cart
$('body').on('login:success', function (e, data) {
    if ($('.tab-subscription-pdp').hasClass('active')) {
        var formSubscription = cartHelpers.getCookie('dataCart');

        if(formSubscription === ""){
            return;
        }

        addToCartSendData($('.add-to-cart-url').val(), JSON.parse(formSubscription));
        document.cookie = 'dataCart=; expires=Wed, 1 Jan 1970 13:47:11 UTC; path=/';
    }
});

$('body').on('login:register:success', function (e, data) {
    if ($('.tab-subscription-pdp').hasClass('active')) {
        var formSubscription = cartHelpers.getCookie('dataCart');

        if(formSubscription === ""){
            return;
        }

        addToCartSendData($('.add-to-cart-url').val(), JSON.parse(formSubscription));
        document.cookie = 'dataCart=; expires=Wed, 1 Jan 1970 13:47:11 UTC; path=/';
    }
});

function validateCustomerAuthentication(isCustomerAuthenticatedUrl) {
    let isCustomerAuthenticated = false;

    $.ajax({
        url: isCustomerAuthenticatedUrl,
        method: 'GET',
        async: false,
        success: function (data) {
            isCustomerAuthenticated = data.isCustomerAuthenticated;
        },
        error: function () {
            $.spinner().stop();
        }
    });

    return isCustomerAuthenticated;
}

function generateDiopterInformation(activeTabSelector, dataRecetaContacto) {
    var ejeIzqContacto = $(activeTabSelector + ' .selecciona-axis-left').val();
    var diametroIzqContacto = $(activeTabSelector + ' .selecciona-dmtr-left').val();
    var curvaturaIzqContacto = $(activeTabSelector + ' .selecciona-crvt-left').val();
    var AddIzqContacto = $(activeTabSelector + ' .selecciona-adds-left').val();
    var sphIzqContacto = $(activeTabSelector + ' .selecciona-sph-left').val();
    var cylIzqContacto = $(activeTabSelector + ' .selecciona-cyl-left').val();
    var CantidadOjoIzq = ($(activeTabSelector + ' .consulta-quant-left-eye').val()  > 0 ? $(activeTabSelector + ' .consulta-quant-left-eye').val() : $(activeTabSelector + ' .receta-quant-left-eye').val() > 0 ? $(activeTabSelector + ' .receta-quant-left-eye').val() : '0');
    var ejeDerContacto = $(activeTabSelector + ' .selecciona-axis-right').val();
    var diametroDerContacto = $(activeTabSelector + ' .selecciona-dmtr-right').val();
    var curvaturaDerContacto = $(activeTabSelector + ' .selecciona-crvt-right').val();
    var AddDerContacto = $(activeTabSelector + ' .selecciona-adds-right').val();
    var sphDerContacto = $(activeTabSelector + ' .selecciona-sph-right').val();
    var cylDerContacto = $(activeTabSelector + ' .selecciona-cyl-right').val();
    var CantidadOjoDer = ($(activeTabSelector + ' .consulta-quant-right-eye').val() > 0 ? $(activeTabSelector + ' .consulta-quant-right-eye').val() : $(activeTabSelector + ' .receta-quant-right-eye').val() > 0 ? $(activeTabSelector + ' .receta-quant-right-eye').val() : '0');

    //ojo Izquierdo
    if(ejeIzqContacto) {
        dataRecetaContacto.ojoIzquierdo.eje = ejeIzqContacto;
    }
    if(diametroIzqContacto) {
        dataRecetaContacto.ojoIzquierdo.diametro = diametroIzqContacto;
    }
    if(curvaturaIzqContacto) {
        dataRecetaContacto.ojoIzquierdo.curvatura = curvaturaIzqContacto;
    }
    if(AddIzqContacto) {
        dataRecetaContacto.ojoIzquierdo.Add = AddIzqContacto;
    }
    if(sphIzqContacto) {
        dataRecetaContacto.ojoIzquierdo.sph = sphIzqContacto;
    }
    if(cylIzqContacto) {
        dataRecetaContacto.ojoIzquierdo.cyl = cylIzqContacto;
    }
    if (CantidadOjoIzq) {
        dataRecetaContacto.ojoIzquierdo.Cantidad = parseInt(CantidadOjoIzq,10);
    } else {
        dataRecetaContacto.ojoIzquierdo.Cantidad = 0;
    }

    //ojo Derecho
    if(ejeDerContacto) {
        dataRecetaContacto.ojoDerecho.eje = ejeDerContacto;
    }
    if(diametroDerContacto) {
        dataRecetaContacto.ojoDerecho.diametro = diametroDerContacto;
    }
    if(curvaturaDerContacto) {
        dataRecetaContacto.ojoDerecho.curvatura = curvaturaDerContacto;
    }
    if(AddDerContacto) {
        dataRecetaContacto.ojoDerecho.Add = AddDerContacto;
    }
    if(sphDerContacto) {
        dataRecetaContacto.ojoDerecho.sph = sphDerContacto;
    }
    if(cylDerContacto) {
        dataRecetaContacto.ojoDerecho.cyl = cylDerContacto;
    }
    if (CantidadOjoDer) {
        dataRecetaContacto.ojoDerecho.Cantidad = parseInt(CantidadOjoDer,10);
    } else {
        dataRecetaContacto.ojoDerecho.Cantidad = 0;
    }

    return dataRecetaContacto;
}

function addToCart () {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
        const pdpHelpers = require('./pdpHelpers');
        const recetaHelpers = require('./recetaHelpers');
        const activeTabSelector = pdpHelpers.resolveActiveTabSelector();
        const isCustomerAuthenticatedUrl = $('.backgroundCtn').data('is-customer-authenticate-url');

        if (!isCustomerAuthenticatedUrl) {
            alert($('.alert .warning').html());
            return;
        }

        let isCustomerAuthenticated = validateCustomerAuthentication(isCustomerAuthenticatedUrl);

        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        pid = baseImported.getPidValue($(this));
        if(!recetaHelpers.canBeAddedToCart()) {
            alert($('.alert .warning').html());
            return;
        }

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            $('.product-detail').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: baseImported.getOptions($(this))
                    });
                }
            });

            pidsObj = JSON.stringify(setPids);
        }

       

        var $productContainer = $(this).closest('.product-detail');

        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }

        let selectedSubscriptionPlan = false;

        let planId;
        let selectedQuantityEyes;
        let selectedEye;
        if (pdpHelpers.isTabSuscriptionActive() &&
            $('#nav-subscription .step1 input[type="radio"]:checked').val() &&
            $('#subscriptionPlansSelect option').filter(':selected').val()) {
                selectedSubscriptionPlan = true;
                planId = $('#subscriptionPlansSelect option').filter(':selected').val();
                selectedQuantityEyes = $('#nav-subscription .step1 input[type="radio"]:checked').val();
                selectedEye = $('#nav-subscription .step1dot1 input[type="radio"]:checked').val();
        }

        addToCartUrl = baseImported.getAddToCartUrl();
        var recetUrl = $(activeTabSelector + ' [data-url-receta]').val();
        var dataUse = $(activeTabSelector + ' [data-use]').data('use');
        var pupillarDistance = $(activeTabSelector + ' [data-pupillar-distance]').val();

        let dataReceta;

        try {
            if(dataUse) {
                dataReceta = JSON.stringify($(activeTabSelector + ' [' + dataUse + ']').data('receta-completa'));
            } else {
                dataReceta = JSON.stringify($(activeTabSelector + ' [data-receta-completa]').data('receta-completa'));
            }
        } catch(e) { }

        var tipoProducto = $('[data-tipo-producto]').val();
        let color = null;
        let parent = null;

        if($('.adds-extra-switchs:checked').length > 0) {
            parent = $('.adds-extra-switchs:checked').data('adds-extra').Id;
        }

        if($('.extra-filter-switchs:checked').length > 0) {
            parent = $('.extra-filter-switchs:checked').data('filter-id');
        }
        
        if($('.color-switch-options:checked').length > 0) {
            let $colorOption = $('.color-switch-options:checked')
            if(!$colorOption.data('color-id') && !$colorOption.data('idsend')){
                $colorOption = $('.js-color-section .color-switch-options:checked')
            }

            color = $colorOption.data('labname') || $colorOption.data('displayname') || $colorOption.data('color-id') || $colorOption.data('idsend');
            parent = $colorOption.data('sku') || parent;
        }

        if($('.adds-sub-colors:checked').length > 0) {
            color = $('.adds-sub-colors:checked').data('displayname');
        }

        if($('.extra-filter-switchs-fotocromatic:checked').length > 0) {
           color = $('.extra-filter-switchs-fotocromatic:checked').data('idsend');
           parent = $('.extra-filter-switchs-fotocromatic:checked').data('sku');
        }

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: baseImported.getChildProducts(),
            quantity: base.getQuantitySelected($(this)),
            tipoProducto: tipoProducto,
            selectedSubscriptionPlan,
            planId,
            selectedQuantityEyes,
            selectedEye
        };

        form.isSunRx = $("#switch-to-cristales").length > 0 ? $("#switch-to-cristales").prop("checked") : false;

        if ($('input[name=vision-type]:checked').val()) {
            form.visionType = $('input[name=vision-type]:checked').val();
        }

        if ($('[data-flow-store-subscription]').data('flow-store-subscription')) {
            form.selectDatePlanSubscription = $('#select-date-plan').val();
        }

        if(parent && color) {
            var colorLensAddOn = {
                parent: parent,
                color: color,
            }

            if(colorLensAddOn.parent !== undefined && colorLensAddOn.color!==undefined) {
                form.colorLensAddOnParent= colorLensAddOn.parent;
                form.colorLensAddOnColor= colorLensAddOn.color;
            }
        }

        if(recetUrl !== undefined){
            form.recetUrl= recetUrl;
        }

        if(dataReceta !== undefined){
            form.dataReceta = dataReceta;
        }

        if(pupillarDistance !== undefined){
            form.pupillarDistance = pupillarDistance;
        }

        if (tipoProducto === 'lenteContacto') {
            const dataRecetaContacto = {
                ojoIzquierdo: {
                    ojo: 'Izquierdo'
                },
                ojoDerecho: {
                    ojo: 'Derecho'
                }
            };

            generateDiopterInformation(activeTabSelector, dataRecetaContacto);

            form.dataRecetaContacto = JSON.stringify(dataRecetaContacto);
        }

        if (!$('.bundle-item').length) {
            form.options = baseImported.getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);

        if (!isCustomerAuthenticated && pdpHelpers.isTabSuscriptionActive()) {
            $('#subscription.backgroundCtn').toggleClass('d-none');
            document.cookie = 'dataCart='+ JSON.stringify(form) +'; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
            $.spinner().stop();
            return;
        }

        if (addToCartUrl) {
           addToCartSendData(addToCartUrl,form);
        }
    });
};
function addToCartCase () {
    $(document).on('click', 'button.add-to-cart-promo', function (e) {
        var addToCartUrl;
        var pid;

        pid = e.target.dataset.id;
        addToCartUrl = baseImported.getAddToCartUrl();
        var form = {
            pid: pid,
            quantity: 1            
        };

        if (addToCartUrl) {
           addToCartSendData(addToCartUrl,form);
        }
    });
};
function closeModalPromoThanks () {
    $(document).on('click', '.close-case-modal-thanks', function () {
        $('.case-promo-modal').fadeOut();
    });
}
function closeModalPromo () {
    $(document).on('click', '.close-case-modal', function () {
        $('.case-promo-modal').fadeOut();
    });
}
module.exports = {
    addToCart : addToCart,
    addToCartCase:addToCartCase,
    closeModalPromo:closeModalPromo,
    closeModalPromoThanks:closeModalPromoThanks,
    validateCustomerAuthentication : validateCustomerAuthentication,
    addToCartSendData : addToCartSendData,
    generateDiopterInformation : generateDiopterInformation
};
